import * as l from "react";
const e = (c) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...c
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M8.022 17.554c0-4.695-3.585-8.518-8.022-8.518l.663-.034C4.658 8.65 7.833 5.18 8.006.886V.5c0 4.528 3.316 8.217 7.517 8.502l.505.017c-4.406.017-8.006 3.84-8.006 8.535zM15.321 24.5c0-2.776-2.119-5.036-4.742-5.036l.392-.02c2.362-.208 4.238-2.26 4.34-4.797v-.229c0 2.677 1.961 4.858 4.444 5.026l.299.01c-2.604.01-4.733 2.27-4.733 5.046zM20.766 15.941c0-1.896-1.448-3.44-3.24-3.44l.267-.014c1.614-.143 2.896-1.545 2.966-3.279v-.156c0 1.83 1.34 3.32 3.037 3.435l.204.006c-1.78.007-3.234 1.552-3.234 3.448z",
      fill: "#fff"
    }
  )
), t = e;
export {
  t as default
};
